import React, { useCallback } from 'react';
import { fieldToSelect } from 'formik-material-ui';
import { Field } from 'formik';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Chip from '@material-ui/core/Chip';
import ListSubheader from '@material-ui/core/ListSubheader';
import { makeStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

export const CustomSelect = (props: any) => {
  const classes = useStyles();

  const {
    form: { errors, submitCount },
    field: { name },
  } = props;

  const fieldProps = fieldToSelect(props);

  const renderValue = useCallback(
    (selected: string[]) => (
      <div className={classes.chips}>
        {(selected || []).map((value) => (
          <Chip
            color={fieldProps.disabled ? 'default' : 'primary'}
            key={value}
            label={value}
            className={classes.chip}
          />
        ))}
      </div>
    ),
    [classes, fieldProps.disabled]
  );
  const canShowError = errors[name] && !props.disabled && submitCount > 0;
  return (
    <FormControl variant="outlined" className={props.className} error={canShowError}>
      <InputLabel htmlFor={props.name}>{props.label}</InputLabel>
      <Select {...fieldProps} renderValue={props.multiple ? (renderValue as any) : undefined}>
        {(props.options || []).map((option: any) =>
          option.isTitle ? (
            <ListSubheader>{option.label}</ListSubheader>
          ) : (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          )
        )}
      </Select>
      {canShowError && errors[name] && <FormHelperText>{errors[name]}</FormHelperText>}
      {console.log(errors)}
    </FormControl>
  );
};

export const SelectField = (props: any) => <Field {...props} component={CustomSelect} />;
export default SelectField;
